module.exports = __webpack_public_path__ + "media/F_.e256b667.mp3";